import { Metamodel } from 'app/model/base/model';
import { CopySink } from './copysink';
import { IAttribute } from 'app/model/base/annotation';

import { Constants } from 'app/shared/shared-constants';
import { RestResourceDataset } from 'app/model/dataset/rest-resource.dataset';
import { createParameterConfigurationValidator } from 'app/model/adapters/linkedservices/parameter-config.util';
import { ParameterConfig } from '../parameter-config';
import { compressionCodecType } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.rest.copySinkType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(RestResourceDataset) }
})
export class RestResourceCopySink extends CopySink {
    public static readonly REQUEST_TIMEOUT: IAttribute;
    public static readonly REQUEST_INTERVAL: IAttribute;
    public static readonly METHOD: IAttribute;
    public static readonly WRITE_BATCH_SIZE: IAttribute;
    public static readonly HTTP_COMPRESSION_TYPE: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'REQUEST_TIMEOUT',
        display: stringResources.ModelName_Request_Timeout,
        constraint: {
            pattern: Constants.timeoutValidation
        }
    })
    public httpRequestTimeout?: string = '00:05:00';

    @Metamodel.attribute({
        templatable: true,
        association: 'REQUEST_INTERVAL',
        display: stringResources.ModelName_REST_Source_Request_Interval,
        accepts: ['String']
    })
    public requestInterval?: number = 10;

    @Metamodel.attribute({
        templatable: true,
        association: 'METHOD',
        display: stringResources.Dataset_RequestMethod,
        constraint: {
            required: true
        }
    })
    public requestMethod?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BATCH_SIZE',
        display: stringResources.ModelName_REST_Sink_Write_Batch_Size,
        accepts: ['String']
    })
    public writeBatchSize?: number = 10000;

    @Metamodel.attribute({
        display: stringResources.Dataset_AdditionalHeaders,
        constraint: {
            validator: createParameterConfigurationValidator()
        }
    })
    public additionalHeaders?: ParameterConfig[] = [];

    @Metamodel.attribute({
        display: stringResources.ModelName_HttpCompressionType,
        association: 'HTTP_COMPRESSION_TYPE',
        constraint: {
            allowed: [compressionCodecType.none, compressionCodecType.gzip]
        }
    })
    public compressionType?: string = compressionCodecType.none;
}
